import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Input, Row } from "reactstrap"
import { copyButtonHandler } from "utils"
import oneTimeDeepLinkListColumns from "./oneTimeDeepLinkListColumns"
import Flatpickr from "react-flatpickr"
import {
  downloadDeeplinkCodes,
  getEventDeepLinkCodes,
  hideGenerateDeeplinkModal,
  openGenerateDeeplinkModal,
} from "store/actions"
import ModalComponent from "components/Modals"
import GenerateDeeplinkModal from "./generateDeeplinkModal"

const Hyperlinks = ({
  deeplinkUrl,
  deeplinkCodes,
  deeplinkCodesAreLoading,
  openGenerateDeeplinkModal,
  hideGenerateDeeplinkModal,
  generateDeeplinkModalIsOpen,
  getEventDeepLinkCodes,
  event_id,
  downloadDeeplinkCodes,
  vendorConfig,
}) => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [used, setUsed] = useState(true)
  const [unused, setUnused] = useState(true)
  const [batchIdValue, setBatchIdValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "asc",
  })

  const actions = [
    {
      name: "Copy",
      onClick: item => {
        copyButtonHandler(item?.word)
      },
      icon: "bx bx-copy",
      isAvailable: true,
    },
  ]

  const handlePageChange = page => {
    let searchParams = {
      ...(startDate ? { from: startDate } : {}),
      ...(endDate ? { to: endDate } : {}),
      ...(batchIdValue?.trim()?.length > 0 ? { batch_id: batchIdValue } : {}),
      ...((used && unused) || (!used && !unused) ? {} : { used: used ? 1 : 0 }),
    }
    getEventDeepLinkCodes({
      ...defaultOrder,
      event_id: event_id,
      type: 3,
      page: page,
      per_page: 25,
      ...searchParams,
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    let searchParams = {
      ...(startDate ? { from: startDate } : {}),
      ...(endDate ? { to: endDate } : {}),
      ...(batchIdValue?.trim()?.length > 0 ? { batch_id: batchIdValue } : {}),
      ...((used && unused) || (!used && !unused) ? {} : { used: used ? 1 : 0 }),
    }

    getEventDeepLinkCodes({
      o: sortField,
      od: sortOrder,
      event_id: event_id,
      page: 1,
      type: 3,
      per_page: 25,
      ...searchParams,
    })

    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handleSearch = () => {
    if (!used && !unused) {
      setUnused(true)
      setUsed(true)
    }
    let searchParams = {
      ...(startDate ? { from: startDate } : {}),
      ...(endDate ? { to: endDate } : {}),
      ...(batchIdValue?.trim()?.length > 0 ? { batch_id: batchIdValue } : {}),
      ...((used && unused) || (!used && !unused) ? {} : { used: used ? 1 : 0 }),
    }

    getEventDeepLinkCodes({
      ...defaultOrder,
      event_id: event_id,
      page: 1,
      type: 3,
      per_page: 25,
      ...searchParams,
    })

    setShowResetButton(true)
  }

  const handleResetSearch = () => {
    getEventDeepLinkCodes({
      ...defaultOrder,
      event_id: event_id,
      page: 1,
      type: 3,
      per_page: 25,
    })

    setStartDate("")
    setEndDate("")
    setBatchIdValue("")
    setShowResetButton(false)
    setUnused(true)
    setUsed(true)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {!!vendorConfig?.communication_hyperlinks && (
            <React.Fragment>
              <h5 className="mb-3">Communication Hyperlinks</h5>
              <p>
                To invite an end-user to the experience via communication tools
                (like Email or Text), copy the links below:
              </p>
              <Row className="mb-2">
                <Col xs="auto">
                  <span>
                    <label>iOS: </label>
                    {" " + deeplinkUrl?.multiple_use_deeplink + " "}
                    <SaveButton
                      type="button"
                      onClick={() => {
                        copyButtonHandler(deeplinkUrl?.multiple_use_deeplink)
                      }}
                      content="Copy"
                      color="light"
                      size="sm"
                    />
                  </span>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="auto">
                  <span>
                    <label>Android: </label>
                    {" " + deeplinkUrl?.universal_android_url + " "}
                    <SaveButton
                      type="button"
                      onClick={() => {
                        copyButtonHandler(deeplinkUrl?.universal_android_url)
                      }}
                      content="Copy"
                      color="light"
                      size="sm"
                    />
                  </span>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {!!vendorConfig?.nfc_hyperlinks && (
            <React.Fragment>
              <h5 className="my-3">NFC Hyperlinks</h5>
              <p>
                To enable an end-user to Tap an NFC Chip, copy the URI link
                below and write it to the NFC Chip:
              </p>
              <Row className="mb-2">
                <Col xs="auto">
                  <span>
                    <label>iOS & Android - unlimited use: </label>
                    {" " + deeplinkUrl?.multiple_use_deeplink + " "}
                    <SaveButton
                      type="button"
                      onClick={() => {
                        copyButtonHandler(deeplinkUrl?.multiple_use_deeplink)
                      }}
                      content="Copy"
                      color="light"
                      size="sm"
                    />
                  </span>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="auto">
                  <span>
                    <label>iOS & Android - one-time use </label>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <SaveButton
                    type="button"
                    onClick={() => {
                      openGenerateDeeplinkModal()
                    }}
                    content="Generate"
                  />
                </Col>
              </Row>
              {(deeplinkCodes?.data?.length > 0 ||
                (deeplinkCodes?.data?.length === 0 && showResetButton)) && (
                <React.Fragment>
                  <Row className="my-3 d-flex justify-content-end">
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        content="Download"
                        disabled={
                          !deeplinkCodes || deeplinkCodes?.data?.length < 1
                        }
                        onClick={() => {
                          downloadDeeplinkCodes({
                            ...defaultOrder,
                            download: 1,
                            event_id: event_id,
                            page: 1,
                            type: 3,
                            per_page: 25,
                            ...(startDate ? { from: startDate } : {}),
                            ...(endDate ? { to: endDate } : {}),
                            ...(batchIdValue?.trim()?.length > 0
                              ? { batch_id: batchIdValue }
                              : {}),
                            ...((used && unused) || (!used && !unused)
                              ? {}
                              : { used: used ? 1 : 0 }),
                          })
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-center my-2">
                    <Col xs="auto" className="my-1">
                      <Flatpickr
                        className="form-control bg-white"
                        placeholder="Start Date"
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                        }}
                        value={startDate}
                        onChange={(selectedDates, dateStr) => {
                          setStartDate(dateStr)
                        }}
                      />
                    </Col>
                    <Col xs="auto" className="my-1">
                      <Flatpickr
                        className="form-control bg-white"
                        placeholder="End Date"
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                        }}
                        value={endDate}
                        onChange={(selectedDates, dateStr) => {
                          setEndDate(dateStr)
                        }}
                      />
                    </Col>
                    <Col xs="auto" className="my-1">
                      <Input
                        value={batchIdValue}
                        onChange={event => {
                          setBatchIdValue(event.target.value)
                        }}
                        placeholder="Batch ID"
                      />
                    </Col>
                    <Col xs="auto" className="align-content-center my-1">
                      <input
                        checked={used}
                        type="checkbox"
                        className="form-check-input me-2"
                        id="used"
                        onChange={e => setUsed(e.target.checked)}
                      />
                      <label>Used</label>
                    </Col>
                    <Col xs="auto" className="align-content-center my-1">
                      <input
                        checked={unused}
                        type="checkbox"
                        className="form-check-input me-2"
                        id="unused"
                        onChange={e => setUnused(e.target.checked)}
                      />
                      <label>Unused</label>
                    </Col>
                    <Col xs="auto" className="my-1">
                      <SaveButton
                        type="button"
                        content="Filter"
                        onClick={handleSearch}
                      />
                    </Col>
                    {showResetButton && (
                      <Col xs="auto" className="my-1">
                        <SaveButton
                          type="button"
                          content="Reset"
                          color="light"
                          onClick={handleResetSearch}
                        />
                      </Col>
                    )}
                  </Row>
                  <TableComponent
                    columns={oneTimeDeepLinkListColumns()}
                    data={deeplinkCodes?.data || []}
                    actions={actions}
                    loadingData={deeplinkCodesAreLoading}
                    paginationData={{
                      current_page: deeplinkCodes?.current_page,
                      last_page: deeplinkCodes?.last_page,
                      total_items: deeplinkCodes?.total,
                      items_per_page: deeplinkCodes?.per_page,
                      from: deeplinkCodes?.from,
                      to: deeplinkCodes?.to,
                      first_page: 1,
                    }}
                    onPageChange={handlePageChange}
                    onTableSort={handleSort}
                  />
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </CardBody>
      </Card>
      <ModalComponent
        open={generateDeeplinkModalIsOpen}
        onClose={hideGenerateDeeplinkModal}
        size={"sm"}
        title="Generate one-time deeplinks"
      >
        <GenerateDeeplinkModal
          event_id={event_id}
          callback={() => {
            setStartDate("")
            setEndDate("")
            setBatchIdValue("")
            setShowResetButton(false)
            setUnused(true)
            setUsed(true)
            setDefaultOrder({ o: "created_at", od: "desc" })
          }}
          onClose={hideGenerateDeeplinkModal}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  generateDeeplinkModalIsOpen: state.experiences.generateDeeplinkModalIsOpen,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  openGenerateDeeplinkModal: () => dispatch(openGenerateDeeplinkModal()),
  hideGenerateDeeplinkModal: () => dispatch(hideGenerateDeeplinkModal()),
  getEventDeepLinkCodes: values => dispatch(getEventDeepLinkCodes(values)),
  downloadDeeplinkCodes: values => dispatch(downloadDeeplinkCodes(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Hyperlinks)
